import type { LeaveSummaryDto } from '../../../api/hr';
import { GroupedSelect, type GroupedSelectGroup } from '../../../components/shared/GroupedSelect';
import { leaveBalanceLine, leaveTypeTriggerSummary } from './leave-type-groups';
import './leave-type-field.css';

/**
 * 근태 신청 · 휴가 탭 머리 — 잔여 한 줄 + 휴가 유형 선택창 (2026-09-15 · 대시보드 시안 v2 V8).
 *
 * 캡처: `_workspace/design-dashboard-v2/attendance-leave-type-closed.png` · `attendance-leave-type-open.png`.
 * ★ 깃발 `VITE_DASHBOARD_V2` 가 켜졌을 때만 쓰인다 — 꺼져 있으면 모달은 종전 알약 · 잔여 링 그대로다.
 * ★ 묶음 · 막힘 판정은 `leave-type-groups.ts`(순수 함수) — 모달이 신청 단추를 끌 때도 같은 값을 쓴다.
 */
export function LeaveTypeField({
  groups, value, onChange, summary, disabled,
}: {
  groups: readonly GroupedSelectGroup[];
  value: string;
  onChange: (value: string) => void;
  summary: LeaveSummaryDto | null | undefined;
  disabled?: boolean;
}) {
  const line = leaveBalanceLine(summary);
  return (
    <>
      {line && <div className="dw-leave-lead">{line}</div>}
      <div className="dw-field">
        <span className="dw-field__label">휴가 유형</span>
        <GroupedSelect
          ariaLabel="휴가 유형"
          value={value}
          onChange={onChange}
          groups={groups}
          summary={leaveTypeTriggerSummary(groups, value)}
          searchPlaceholder="유형 찾기 — 예: 반차, 경조"
          emptyText="찾는 유형이 없습니다"
          disabled={disabled}
        />
      </div>
    </>
  );
}
